import { rem } from 'polished';
import styled from 'styled-components';

import { IBasicUserType } from '../../types';

export const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${rem('24px')};
  min-width: ${rem('24px')};
  margin-right: ${rem('-4px')};
  margin-left: ${rem('8px')};
  padding: ${rem('8px')};
  color: ${({ theme }) => theme.colors.main};
  font-size: ${rem('12px')};
  font-weight: 700;
  line-height: 1.17;
  border-radius: ${rem('12px')};
`;

export const StyledButton = styled.button<IBasicUserType>`
  display: inline-flex;
  align-items: center;
  height: ${rem('40px')};
  padding: 0 ${rem('16px')};
  background-color: ${({ theme }) => theme.colors.cross.lightGray};
  border: none;
  border-radius: ${rem('20px')};
  appearance: none;
  cursor: pointer;

  ${StyledBadge} {
    background-color: ${({ theme, user }) =>
      user ? theme.colors[user].main : theme.colors.cross.grayson};
  }
`;

export const StyledIcon = styled.span`
  display: inline-flex;
  margin-right: ${rem('8px')};

  svg {
    height: auto;
    width: ${rem('16px')};
  }
`;

export const StyledSpan = styled.span`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('16px')};
  font-weight: 400;
  line-height: 1.4;
`;
